import React, { useState } from 'react'
import { Box, Stack, Typography, Tooltip, Link, IconButton } from '@mui/material'
import { ArrowUpward, ArrowDownward } from '@mui/icons-material'
import CategoryFilterPopover from '../../CategoryFilterPopover'

const CategoriesListControls = ({
  setCategoryExpand, 
  sortCategories,
  categories,
  filterCategories,
  includeSort = true,
  includeFilter = true,
  viewCategories,
  includeCollapse = true,
  defaultSelectedCategories = undefined
}) => {

  const [sortDirection, setSortDirection] = useState('asc')
  const filteredCount = categories?.length === viewCategories?.length ? 0 : viewCategories?.length

  return (
    <Box paddingTop='5px'>
      <Stack direction='row-reverse' columnGap={1} alignItems='baseline'>
        { includeCollapse && <Stack direction='row' columnGap={.75} >
          <Typography variant='body2'>Collapse:</Typography>
          <Tooltip arrow placement='left' title={`Collapse all Category groups`}>
            <Link variant='caption' onClick={() => setCategoryExpand(false)}>All</Link>
          </Tooltip>
          <Tooltip arrow placement='left' title={`Expand all Category groups`}>
            <Link variant='caption' onClick={() => setCategoryExpand(prev => prev + 1)}>None</Link>
          </Tooltip>
        </Stack>}
        { includeSort &&
          <Stack direction='row' columnGap={.75} alignItems='center'>
            <Typography variant='body2'>Sort:</Typography>
            <Tooltip arrow placement='left' title={`Sort Category groups ascending`}>
              <IconButton color={sortDirection === 'asc' ? 'primary' : 'default'} size='small' onClick={() => {
                setSortDirection('asc')
                sortCategories(true)
              }}>
                <ArrowUpward sx={{ maxHeight: '20px'}} />
              </IconButton>
            </Tooltip>
            <Tooltip arrow placement='left' title={`Sort Category groups descending`}>
              <IconButton color={sortDirection === 'desc' ? 'primary' : 'default'} size='small' onClick={() => {
                setSortDirection('desc')
                sortCategories(false)}
              }>
                <ArrowDownward sx={{ maxHeight: '20px'}} />
              </IconButton>
            </Tooltip>
          </Stack>
        }
        { includeFilter && viewCategories &&
            <CategoryFilterPopover
              startingCategories={defaultSelectedCategories}
              trigger={<Tooltip arrow placement='left' title={`Select Desired Categories`}>
                <Link variant="caption" sx={{ textDecoration: 'underline', cursor: 'pointer' }}>{filteredCount > 0 ? `Filtered Categories (${filteredCount})` : `Filter Categories`}</Link>
              </Tooltip>}
              categories={categories}
              onSelection={filterCategories}
            />
        }
      </Stack>
    </Box>
  )
}

export default React.memo(CategoriesListControls)